import { render, staticRenderFns } from "./ZoteroHint.vue?vue&type=template&id=cb1e6134&scoped=true&"
import script from "./ZoteroHint.vue?vue&type=script&lang=js&"
export * from "./ZoteroHint.vue?vue&type=script&lang=js&"
import style0 from "./ZoteroHint.vue?vue&type=style&index=0&id=cb1e6134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1e6134",
  null
  
)

export default component.exports